import { App } from 'antd';
import { useCallback } from 'react';
import { PromoCodeForm } from '../components/PromoCodeForm';
import { useCreatePromoCodeMutation } from '../store/promo-code.api';

export const CreatePromoCode: React.FC = () => {
  const { message } = App.useApp();
  const [createPromoCode, { isSuccess, error }] = useCreatePromoCodeMutation();

  const onFinish = useCallback(
    (values: any) => {
      createPromoCode({
        ...values,
      })
        .unwrap()
        .catch((err) => {
          const errorMessage =
            (err as Record<string, any>)?.data?.errors?.[0]?.message ||
            'Failed to create promo code';
          message.error(errorMessage);
        });
    },
    [createPromoCode, message],
  );

  return <PromoCodeForm onFinish={onFinish} isSubmitted={isSuccess} />;
};
